import ClipLoader from "react-spinners/ClipLoader";
import React from "react";

const Loader = ({ loading }) => {
  return (
    <ClipLoader
      loading={loading}
      color="#005AA7"
      aria-label="Loading Spinner"
      data-testid="loader"
      className={"ajax-loader"}
    />
  );
};

export default Loader;
